import './Theme.Collection.List.scss';
export default 'ThemeCollectionList';
